/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './record.defs.js'
export * as $defs from './record.defs.js'
